import { TooltipPosition } from 'components/controls/Tooltip';
import { LabelGroup } from '../form/styled';
import TooltipErrorIcon from '../icons/TooltipErrorIcon';
import TooltipHelpIcon from '../icons/TooltipHelpIcon';

export type TSmartLabelProps = {
  label: React.ReactNode | undefined;
  tooltip?: string | undefined;
  tooltipPosition?: TooltipPosition;
  labelStyle?: React.CSSProperties;
  boxStyle?: React.CSSProperties;
  required?: boolean;
  hasValue?: boolean;
  htmlFor?: any;
  error?: boolean | string | JSX.Element | null;
  className?: string;
};

const SmartLabel = ({
  label,
  tooltip,
  tooltipPosition,
  required,
  hasValue,
  labelStyle,
  boxStyle,
  htmlFor,
  error,
  className,
}: TSmartLabelProps) => {
  return (
    <LabelGroup style={boxStyle} className={className}>
      <label htmlFor={htmlFor} style={labelStyle}>
        {label}
      </label>
      {tooltip && <TooltipHelpIcon content={tooltip} position={tooltipPosition} />}
      {(error || (required && !hasValue)) && <TooltipErrorIcon content={error || 'Required'} />}
    </LabelGroup>
  );
};

export default SmartLabel;
